import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
declare var $: any;
import { filter } from 'rxjs/operators';
import { PermissionsService } from '../services/permissions.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  interv;
  env;

  constructor(public router: Router, public route: ActivatedRoute, public permissionsService: PermissionsService) {
    this.env = environment;
  }

  async ngOnInit() {
    const interv = setInterval(() => {
      if ($) {
        clearInterval(interv);
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((data: NavigationEnd) => {
          const path = data.url;
          if (path.indexOf('/cobranca') > -1) {
            if (path === '/cobranca') {
              $('.wrappagemenu').find('.card').hide();
              $('.wrappagemenu').find('.cobranca').show();
            } else {
              $('.wrappagemenu').find('.card').show();
            }
          }
        });
      }
    });
  }
}
